"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ɵ0 = function (target, name, value) {
    target[name] && target[name].unsubscribe && !target[name].closed && target[name].unsubscribe();
    target[name] = value;
    return true;
}, ɵ1 = function (target, name) {
    return target[name];
};
exports.ɵ0 = ɵ0;
exports.ɵ1 = ɵ1;
var SubscriptionManagerHandler = {
    set: ɵ0,
    get: ɵ1
};
var SubscriptionManagerHelper = /** @class */ (function () {
    function SubscriptionManagerHelper() {
    }
    SubscriptionManagerHelper.prototype.addSubscription = function (subscription) {
        this.subList = this.subList || [];
        this.subList.push(subscription);
    };
    SubscriptionManagerHelper.prototype.registerSubscription = function () {
        this.subNames = this.subNames || {};
        this.subProxy = this.subProxy || new Proxy(this.subNames, SubscriptionManagerHandler);
        return this.subProxy;
    };
    SubscriptionManagerHelper.prototype.cleanup = function () {
        this.subList && this.subList.forEach(function (s) {
            s && s.unsubscribe && !s.closed && s.unsubscribe();
        });
        if (this.subNames) {
            for (var key in this.subNames) {
                if (this.subNames.hasOwnProperty(key)) {
                    var s = this.subNames[key];
                    s && s.unsubscribe && !s.closed && s.unsubscribe();
                }
            }
        }
    };
    return SubscriptionManagerHelper;
}());
function SubscriptionManager(config) {
    if (config === void 0) { config = null; }
    return function (target) {
        Object.defineProperty(target.prototype, (config && config.name) || '$sm', {
            set: function (subscription) {
                this.$ngSubscriptionManager = this.$ngSubscriptionManager || new SubscriptionManagerHelper();
                this.$ngSubscriptionManager.addSubscription(subscription);
            },
            get: function () {
                this.$ngSubscriptionManager = this.$ngSubscriptionManager || new SubscriptionManagerHelper();
                return this.$ngSubscriptionManager.registerSubscription();
            }
        });
        var ngOnDestroy = target.prototype.ngOnDestroy;
        Object.defineProperty(target.prototype, 'ngOnDestroy', {
            value: function () {
                ngOnDestroy && ngOnDestroy.call(this);
                this.$ngSubscriptionManager && this.$ngSubscriptionManager.cleanup();
            }
        });
    };
}
exports.SubscriptionManager = SubscriptionManager;
//# sourceMappingURL=subscription-manager.decorator.js.map